const getters = {
    customFields: (state) => (section) => state.customFields[section],
    loading: (state) => (section) => state.loading[section]
};

export default getters;